//en.js
export default {
  index: {
    content: `Embrace the future of data, algorithms and computing power`,
    contentInfo:'Enhance the consumer experience with video and intelligence',
    cultureTitle: 'Our Culture',
    culture: `Collaborate efficiently through honest communication,
            Defend point of view by data and fact,
            Pursue to be an acknowledged high performer.`,
    posterTitle: 'GhostCut',
    poster: 'A creative editing tool that helps clients create great local video ideas.',
    go: 'Get started',
    videoTitle: 'DozyCat',
    video: 'An automated system that multiplies the efficiency of creative management through RPA and AI technology.',
    joinTitle: 'Join Us',
    join: 'In an area with great potential of growing exponentially, we believe that data, algorithms, and computing power will pave our way to success. Welcome to join us.',
    company:'Shanghai Zhaoli Technology Co., Ltd',
    Abbreviation:'zhaoli',
    RecordInfo:'Shanghai ICP Prepared 19019916-2',
  }
}

